import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { LocaleFragment } from '../../../fragments/LocaleFragment'

const query = gql`
  query locales {
    locales {
      ...LocaleFragment
    }
  }
  ${LocaleFragment}
`

const transformer = (data: any) => {
  return data?.locales
}

export default queryServiceCreator(query, transformer)
